import mutations from '@/store/modules/browser/browserCommonState/browser.mutations';
import actions from '@/store/modules/browser/browserCommonState/browser.actions';
import getters from '@/store/modules/browser/browserCommonState/browser.getters';
import { CAPABILITY_BROWSER } from '@/utils/constants';
import { NAVTABS } from '@/utils/templates/Browser/browser.constants';
export interface State {
  currentTab: string;
  capability: string;
  browserServices: any[];
  versions: any[];
  browserPages: any[];
  currentBrowserService: any;
  currentBrowserVersion: any;
  currentBrowserPage: any;
  syntheticUserEnabled: Boolean;
  browserApdexEnabled: any;
}

const initialState: State = {
  currentTab: NAVTABS.BROWSER_APPLICATION_TAB,
  capability: CAPABILITY_BROWSER,
  browserServices: [],
  browserPages: [],
  versions: [],
  currentBrowserService: {},
  currentBrowserVersion: {},
  currentBrowserPage: {},
  syntheticUserEnabled: false,
  browserApdexEnabled: false,
};

export default {
  namespaced: true,
  state: initialState,
  mutations: mutations,
  actions: actions,
  getters: getters
};
